import {pullRequestsAppBuilder} from '../config/app-builder'

export const pullRequestsConversationsRoute = pullRequestsAppBuilder.createQueryRouteConfig(
  'pullRequestsConversationsRoute',
  {
    path: '/:owner/:repo/pull/:pr_number',
    index: true,
  },
)
